/**
 * dd-photo-album.js — 游客照片墙（相册列表页）交互
 *
 * 1. 筛选栏：全部 / 按国家（country）/ 按行程（itinerary）单选筛选，更新结果数量
 * 2. 卡片：卡内左右切换照片（箭头 + 拖动 + 计数 + 圆点）
 * 3. 大图预览：点击图片或文案区打开 dd-image-viewer，定位到当前展示那张
 * 4. 区块入场：卡片逐级上浮
 *
 * 无 JS 降级：筛选不生效但显示全部相册；卡片显示第一张照片；入场动效由 3 秒兜底计时器取消。
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-dd-photo-album]');
  if (!root || root.dataset.ddPhotoAlbumReady === 'true') return;
  root.dataset.ddPhotoAlbumReady = 'true';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ */
  /*  1. 筛选                                                           */
  /*     data-filter 取值：all | country:<国家> | itinerary:<城市>       */
  /* ------------------------------------------------------------------ */
  function initFilters() {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-dd-pa-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-dd-pa-card]'));
    var empty = root.querySelector('[data-dd-pa-empty]');
    var count = root.querySelector('[data-dd-pa-count]');
    if (!buttons.length || !cards.length) return;

    function matches(card, value) {
      if (!value || value === 'all') return true;
      var sep = value.indexOf(':');
      var type = sep === -1 ? value : value.slice(0, sep);
      var key = sep === -1 ? '' : value.slice(sep + 1);
      if (type === 'country') return (card.getAttribute('data-country') || '') === key;
      if (type === 'itinerary') {
        return (card.getAttribute('data-itinerary') || '').split('|').indexOf(key) !== -1;
      }
      return true;
    }

    function apply(value) {
      var shown = 0;
      cards.forEach(function (card) {
        var ok = matches(card, value);
        card.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = shown;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (item) {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        apply(button.getAttribute('data-filter'));
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  2. 卡片：卡内左右切换照片                                          */
  /* ------------------------------------------------------------------ */
  function initCarousels() {
    root.querySelectorAll('[data-dd-pa-media]').forEach(function (media) {
      var slides = Array.prototype.slice.call(media.querySelectorAll('.dd-pa-card__slide'));
      if (slides.length < 2) return;

      var badge = media.querySelector('[data-dd-pa-count-badge]');
      var dotsBox = media.querySelector('[data-dd-pa-dots]');
      var index = 0;
      var dots = [];

      if (dotsBox) {
        dots = slides.map(function (_, i) {
          var dot = document.createElement('span');
          dot.className = 'dd-pa-card__dot' + (i === 0 ? ' is-active' : '');
          dotsBox.appendChild(dot);
          return dot;
        });
      }

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        if (badge) badge.textContent = (index + 1) + ' / ' + slides.length;
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      media.querySelectorAll('[data-dd-pa-prev]').forEach(function (button) {
        button.addEventListener('click', function () { show(index - 1); });
      });
      media.querySelectorAll('[data-dd-pa-next]').forEach(function (button) {
        button.addEventListener('click', function () { show(index + 1); });
      });

      // 触摸 / 鼠标拖动切换
      var startX = null;
      var suppressClick = false; // 拖拽切换后紧跟的 click 不要顺带打开大图
      media.addEventListener('pointerdown', function (event) {
        suppressClick = false;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        startX = event.clientX;
      });
      media.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 40) return;
        suppressClick = true;
        show(index + (delta < 0 ? 1 : -1));
      });
      media.addEventListener('pointercancel', function () { startX = null; suppressClick = false; });
      // 捕获阶段拦下拖拽后的 click，阻止 dd-image-viewer 的 document 点击监听
      media.addEventListener('click', function (event) {
        if (!suppressClick) return;
        suppressClick = false;
        event.stopPropagation();
      }, true);

      show(0);
    });
  }

  /* ------------------------------------------------------------------ */
  /*  3. 大图预览：点击文案区打开（图片点击由 dd-image-viewer 的声明式绑定处理） */
  /* ------------------------------------------------------------------ */
  function initViewer() {
    root.querySelectorAll('[data-dd-pa-body]').forEach(function (body) {
      var card = body.closest('.dd-pa-card');
      var media = card ? card.querySelector('[data-dd-pa-media]') : null;
      if (!media) return;
      var viewerId = media.getAttribute('data-dd-album');

      function open() {
        if (!window.DDImageViewer || !viewerId) return; // 预览器脚本未加载时静默跳过
        var slides = Array.prototype.slice.call(media.querySelectorAll('.dd-pa-card__slide'));
        if (!slides.length) return;
        var list = slides.map(function (img) {
          return { src: img.currentSrc || img.src, alt: img.alt || '' };
        });
        var active = 0;
        slides.forEach(function (img, i) {
          if (img.classList.contains('is-active')) active = i;
        });
        window.DDImageViewer.open(viewerId, list, active);
      }

      body.addEventListener('click', open);
      body.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          open();
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  4. 入场动效                                                       */
  /* ------------------------------------------------------------------ */
  function initReveal() {
    var items = root.querySelectorAll('.dd-pa-reveal');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------ */
  initFilters();
  initCarousels();
  initViewer();
  initReveal();

  window.__ddPhotoAlbumReady = true;
})();
